import React, { useState, useEffect, useCallback } from "react";
import styled from "styled-components";
import api from "../../api";
import { useMealMate } from "../../context/MealMateContext";
import { useNavigate } from "react-router-dom";
import SideNavAccount from "../../components/SideNav/SideNavAccount";
import { message, Pagination } from "antd";
import moment from 'moment';

// ======================= Styled Components =======================
const HistoryPageWrapper = styled.div`
  display: flex;
  min-height: 100vh;
  background-color: #f8f9fa;
`;

const MainContent = styled.div`
  flex: 1;
  padding: 2.5rem 3rem;
  background-color: #f8f9fa;
  
  h1 {
    font-size: 2.8rem;
    color: #2c3e50;
    margin-bottom: 2.5rem;
    text-align: center;
    font-weight: 700;
    letter-spacing: -0.05rem;
  }
`;

const HistoryList = styled.div`
  display: grid;
  /* Đảm bảo luôn có 2 cột nếu có đủ không gian, hoặc 1 cột nếu không */
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr)); 
  gap: 1.8rem;
  margin-bottom: 2.5rem;
  /* Thay đổi: Sử dụng auto-flow dense để lấp đầy các khoảng trống */
  /* Remove justify-content: center; from here, we will center the grid itself */

  /* Để căn giữa lưới, chúng ta sẽ áp dụng margin auto */
  max-width: 900px; /* Đặt một max-width để lưới không quá rộng */
  margin-left: auto;
  margin-right: auto;

  @media (max-width: 1200px) {
    grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
    max-width: 700px; /* Adjust max-width for smaller screens */
  }
  @media (max-width: 768px) {
    grid-template-columns: 1fr; /* 1 cột trên màn hình nhỏ */
    padding: 0 1rem;
    max-width: 400px; /* Adjust max-width for mobile */
  }
`;

const HistoryCard = styled.div`
  background: linear-gradient(145deg, #ffffff, #f0f0f0);
  padding: 1.8rem;
  border-radius: 20px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.08);
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  border: 1px solid #e9ecef;

  &:hover {
    transform: translateY(-10px) scale(1.02);
    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.15);
  }
`;

const HistoryHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  padding-bottom: 1.2rem;
  border-bottom: 1px solid #e0e0e0;

  h3 {
    font-size: 1.7rem;
    color: #34495e;
    margin: 0;
    font-weight: 600;
  }

  span {
    font-size: 1.6rem;
    font-weight: bold;
    color: #28a745;
    background-color: #e6ffed;
    padding: 0.5rem 1rem;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(40, 167, 69, 0.2);
  }
`;

const NutritionSummaryHistory = styled.div`
  display: flex;
  justify-content: space-around;
  margin-top: 1rem;
  padding-top: 1.5rem;
  border-top: 1px dashed #dcdcdc;
`;

const NutritionItemHistory = styled.div`
  text-align: center;
  font-size: 1.05rem;
  color: #6c757d;

  span {
    display: block;
    font-weight: bold;
    color: #495057;
    margin-top: 0.6rem;
    font-size: 1.25rem;
  }
`;

const NoHistoryMessage = styled.p`
  text-align: center;
  font-size: 1.3rem;
  color: #777;
  padding: 3.5rem;
  border: 2px dashed #aed6f1;
  border-radius: 15px;
  margin-top: 3.5rem;
  background-color: #eaf6ff;
  box-shadow: 0 3px 12px rgba(0,0,0,0.06);
  max-width: 600px; /* Thêm max-width cho tin nhắn không có lịch sử */
  margin-left: auto;
  margin-right: auto;
`;

const PaginationWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 3rem;

  .ant-pagination-item {
    border-radius: 10px;
    font-size: 1.05rem;
    border: 1px solid #ced4da;
    background-color: #ffffff;
    &:hover {
      border-color: #87ceeb;
      a {
        color: #1e90ff;
      }
    }
  }

  .ant-pagination-item-active {
    background-color: #6a8bad;
    border-color: #6a8bad;
    a {
      color: white;
    }
    &:hover {
      background-color: #5a7b9c;
      border-color: #5a7b9c;
    }
  }

  .ant-pagination-prev, .ant-pagination-next {
    .ant-pagination-item-link {
      border-radius: 10px;
      border: 1px solid #ced4da;
      background-color: #ffffff;
      &:hover {
        border-color: #87ceeb;
        color: #1e90ff;
      }
    }
  }
`;

// ======================= EatingHistoryPage Component =======================
const EatingHistoryPage = () => {
  const [historyData, setHistoryData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { user } = useMealMate();
  const navigate = useNavigate();

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 4;

  const fetchHistoryData = useCallback(async () => {
    if (!user) {
      setLoading(false);
      setError("Bạn cần đăng nhập để xem lịch sử ăn uống.");
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const res = await api.get("/daily/all");
     

      const sortedData = res.data.sort((a, b) => new Date(b.date) - new Date(a.date));
      setHistoryData(sortedData);
    } catch (err) {
      console.error("Lỗi khi lấy lịch sử ăn uống:", err);
      let errorMessage = "Không thể tải lịch sử ăn uống. Vui lòng thử lại.";
      if (err.response && err.response.data && err.response.data.message) {
        errorMessage = err.response.data.message;
      } else if (err.message) {
        errorMessage = err.message;
      }
      setError(errorMessage);
      message.error(errorMessage);
    } finally {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => {
    fetchHistoryData();
  }, [fetchHistoryData]);

  const handleViewDayDetails = useCallback((dateString) => {
    navigate('/account/daily-menu', { state: { selectedDate: dateString } });
  }, [navigate]);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = historyData.slice(indexOfFirstItem, indexOfLastItem);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  return (
    <HistoryPageWrapper>
      <SideNavAccount />
      <MainContent>
        <h1>Lịch sử ăn uống</h1>
        {loading ? (
          <p style={{ textAlign: 'center', padding: '2rem', fontSize: '1.1rem', color: '#555' }}>Đang tải lịch sử ăn uống...</p>
        ) : error ? (
          <p style={{ color: 'red', textAlign: 'center', padding: '2rem', fontSize: '1.1rem' }}>{error}</p>
        ) : historyData.length > 0 ? (
          <>
            <HistoryList>
              {currentItems.map((menu) => (
                <HistoryCard
                  key={menu._id}
                  onClick={() => handleViewDayDetails(menu.date)}
                >
                  <HistoryHeader>
                    <h3>Ngày: {moment(menu.date).format('dddd, DD/MM/YYYY')}</h3>
                    <span>{Math.round(menu.totalCalories || 0)} kcal</span>
                  </HistoryHeader>
                  <NutritionSummaryHistory>
                    <NutritionItemHistory>Protein: <span>{Math.round(menu.totalProtein || 0)}g</span></NutritionItemHistory>
                    <NutritionItemHistory>Chất béo: <span>{Math.round(menu.totalFat || 0)}g</span></NutritionItemHistory>
                    <NutritionItemHistory>Carb: <span>{Math.round(menu.totalCarbs || 0)}g</span></NutritionItemHistory>
                  </NutritionSummaryHistory>
                </HistoryCard>
              ))}
            </HistoryList>
            {/* Chỉ hiển thị phân trang nếu có nhiều hơn 1 trang */}
            {historyData.length > itemsPerPage && (
              <PaginationWrapper>
                <Pagination
                  current={currentPage}
                  pageSize={itemsPerPage}
                  total={historyData.length}
                  onChange={handlePageChange}
                  showSizeChanger={false}
                />
              </PaginationWrapper>
            )}
          </>
        ) : (
          <NoHistoryMessage>Chưa có lịch sử ăn uống nào. Hãy tạo thực đơn hàng ngày để xem lịch sử!</NoHistoryMessage>
        )}
      </MainContent>
    </HistoryPageWrapper>
  );
};

export default EatingHistoryPage;